import { network } from 'services/network';

export const getCustomerUsersList = () => {
    return network.get('api/bo/getUsers').then((response) => {
        return response.data;
    });
};
